var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("div", [
          _c("p", {
            staticClass: "icon-jujue closeBtn",
            on: { click: _vm.routerBack },
          }),
        ]),
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                ref: "queryCondition",
                staticClass: "searchForm",
                attrs: {
                  model: _vm.queryCondition,
                  "label-position": _vm.labelPosition,
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Category3",
                                      prop: "category3Code",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value:
                                            _vm.queryCondition.category3Code,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "category3Code",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.category3Code",
                                        },
                                      },
                                      _vm._l(
                                        _vm.category3List,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.object,
                                              value: item.key,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Sponsor",
                                      prop: "sponsorName",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.sponsorName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "sponsorName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryCondition.sponsorName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Farm Group",
                                      prop: "farmGroup",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.farmGroup,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "farmGroup",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.farmGroup",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "商品名",
                                      prop: "productName",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.productName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "productName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryCondition.productName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-collapse-transition",
                      [
                        _vm.isShow
                          ? _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "用途分类",
                                              prop: "useClass",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  placeholder: "请选择",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition.useClass,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "useClass",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.useClass",
                                                },
                                              },
                                              _vm._l(
                                                _vm.useClassList,
                                                function (item, index) {
                                                  return _c("el-option", {
                                                    key: index,
                                                    attrs: {
                                                      label: item.name,
                                                      value: item.code,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "有效成分",
                                              prop: "effectiveComponents",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  placeholder: "请选择",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .effectiveComponents,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "effectiveComponents",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.effectiveComponents",
                                                },
                                              },
                                              _vm._l(
                                                _vm.effectiveComponentsList,
                                                function (item, index) {
                                                  return _c("el-option", {
                                                    key: index,
                                                    attrs: {
                                                      label: item.name,
                                                      value: item.code,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "药品状态",
                                              prop: "medicineUseStatus",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                table:
                                                  "TT_RMC_PRODUCE_MEDICINE",
                                                filterable: "",
                                                field: "MEDICINE_USE_STATUS",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .medicineUseStatus,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "medicineUseStatus",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.medicineUseStatus",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  {
                    attrs: { type: "flex", justify: "center", align: "middle" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.queryData },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.onReset },
                      },
                      [_vm._v("重置")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "arrowDown",
                        on: {
                          click: function ($event) {
                            _vm.isShow = !_vm.isShow
                          },
                        },
                      },
                      [
                        _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                        _c("i", {
                          class: _vm.isShow
                            ? "el-icon-arrow-up iconBtn"
                            : "el-icon-arrow-down iconBtn",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "ux-grid",
          {
            ref: "plxTable",
            attrs: {
              data: _vm.tableData,
              "max-height": "500",
              "show-overflow": "tooltip",
              "highlight-current-row": "",
            },
            on: { "selection-change": _vm.selectionChange },
          },
          [
            _c("ux-table-column", {
              attrs: { align: "center", type: "checkbox", width: "80" },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "提交时间",
                field: "submitDate",
                width: "120",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "修改原因",
                field: "modifyReason",
                width: "120",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "药品状态",
                field: "medicineUseStatusI18n",
                width: "120",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "Category3",
                field: "category3Name",
                width: "120",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "Sponsor",
                "min-width": "100",
                field: "sponsorName",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "Farm",
                "min-width": "120",
                field: "farmName",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "Farm Group",
                "min-width": "140",
                field: "farmGroup",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "商品名",
                "min-width": "120",
                field: "productName",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "用途分类",
                "min-width": "100",
                field: "useClass",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "作物名称",
                "min-width": "120",
                field: "cultiVarName",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "有效成分",
                "min-width": "120",
                field: "effectiveComponents",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "含量",
                "min-width": "120",
                field: "contents",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "安全间隔期/天",
                "min-width": "120",
                field: "safetyDay",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "生产厂家",
                "min-width": "120",
                field: "producer",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "剂型",
                "min-width": "120",
                field: "dosageForm",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "使用方法",
                "min-width": "120",
                field: "usage",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "指导用量",
                "min-width": "120",
                field: "guideUsage",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "最多使用次数/季",
                "min-width": "120",
                field: "maximum",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "农药登记证号",
                "min-width": "120",
                field: "pesticideNumber",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "GB 2763",
                "min-width": "120",
                field: "finiteQuantity",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "其他标准",
                "min-width": "120",
                field: "otherStandard",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "检测报告",
                "min-width": "120",
                field: "createDate",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-button", { attrs: { type: "text" } }, [
                        _vm._v("查看"),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "提交人",
                "min-width": "120",
                field: "submitUser",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.queryCondition.pageNum,
                "page-sizes": _vm.pageSizeList,
                "page-size": _vm.queryCondition.pageSize,
                layout: _vm.pageLayout,
                total: _vm.totalCount,
              },
              on: {
                "size-change": _vm.pageSizeChange,
                "current-change": _vm.pageNumberChange,
              },
            }),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "",
              visible: _vm.fileleDialog,
              width: "60%",
              "before-close": _vm.closeFileDialog,
            },
            on: {
              "update:visible": function ($event) {
                _vm.fileleDialog = $event
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "header-title",
                attrs: { slot: "title" },
                slot: "title",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info_box_title",
                    staticStyle: {
                      "padding-left": "10px",
                      "box-sizing": "border-box",
                    },
                  },
                  [
                    _c("p", { staticClass: "line" }),
                    _c("p", { staticClass: "info_title" }, [
                      _vm._v("检测报告"),
                    ]),
                  ]
                ),
              ]
            ),
            _vm.fileleDialog
              ? _c("fileleDialog", { attrs: { fileList: _vm.fileList } })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }